import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquarePlaceholderDashed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-placeholder-dashed"><path d="M5.7 3.75H3.75V5.75M18.25 3.75H20.25V5.75M3.75 18.25V20.25H5.7M18.25 20.25H20.25V18.25M10.25 3.75H13.75M20.25 10.25V13.75M13.75 20.25H10.25M3.75 13.75V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquarePlaceholderDashed;
